/** Spinner mic + etichetă, pentru stările de încărcare (mai clar decât text simplu). */
export function Spinner({ label, className = '' }: { label?: string; className?: string }) {
  return (
    <div
      className={`flex items-center gap-2 text-sm text-b4l-text-muted ${className}`}
      role="status"
      aria-live="polite"
    >
      <span
        aria-hidden="true"
        className="h-4 w-4 animate-spin rounded-full border-2 border-b4l-blue/30 border-t-b4l-blue motion-reduce:animate-none"
      />
      {label && <span>{label}</span>}
    </div>
  )
}
